<template>
  <div>
    <van-form>
        <van-field
            v-model="recordLoginText"
            label="号码:"
            placeholder="请输入号码"
            readonly
            disabled=true
        >
        </van-field>
        <van-field
            v-model="cancelRealNameInfo.applyName"
            name="name"
            label="姓名："
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field
            v-model="cancelRealNameInfo.applyPhone"
            name="mobile"
            label="手机号："
            placeholder="请输入手机号"
            :rules="[{ required: true, message: '请输入手机号' }]"
        />
        <van-field
            v-model="cancelRealNameInfo.applyIDCard"
            name="identity"
            label="身份证号："
            placeholder="请输入身份证号"
            :rules="[{ required: true, message: '请输入身份证号' }]"
        />
        <van-field
            v-model="cancelRealNameInfo.remark"
            name="remark"
            label="申请备注："
        />
        <van-field
            v-model="cancelRealNameInfo.processState"
            name="processState"
            label="处理状态："
            disabled
        />
        <van-field
            v-model="cancelRealNameInfo.processResult"
            name="processResult"
            label="处理结果："
            disabled
        />
        <div style="padding:2px 10px">
            <p class="tips">{{tips.text1}}</p>
            <p class="tips">{{tips.text2}}</p>
        </div>
        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" :disabled="isdisabled" @click="onSubmit">
            提交
            </van-button>
        </div>
    </van-form>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import {wxRequest} from '@/api/user.js'

export default {
    data() {
        return {
            recordLoginText:localStorage.getItem('recordLoginText'),
            cancelRealNameInfo: {
                iccid: localStorage.getItem('iccid'),
                applyName: null,
                applyPhone: null,
                applyIDCard: null,
                remark:null,
                processState: null,
                processResult: null,
                supplierCode: localStorage.getItem('supplierCode'),
                supplierName: localStorage.getItem('supplierName'),
                supplierType: localStorage.getItem('supplierTypeCode'),
            },
            isdisabled: false,
            tips: {
                text1: '1、当前SIM卡业务要求需要实名，注销当前SIM卡实名制信息会造成SIM卡永久注销。再也无法使用！',
                text2: '2、注销实名提交后后台1-3个工作日内会审核，请留意审核结果，如有问题请在公众号联系客服！'
            }
        }
    },
    methods: {
        onSubmit() {
            if(this.cancelRealNameInfo.applyPhone == localStorage.getItem('mobile')) {
                wxRequest('wxAuth/unbind',this.cancelRealNameInfo,'post').then(res => {
                if(res.data.code == 200) {
                    Dialog.alert({title:'提示', message: res.data.message});
                }
                else {
                    Dialog.alert({title:'提示', message: res.data.message});
                }
            })
            }
            else {
                Dialog.alert({title:'提示', message: "手机号不一致"});
            }
        },
    },
    created() {
        let data= {
            iccid: localStorage.getItem('iccid')
        }
        wxRequest('wxAuth/isUnbind',data,'post').then(res =>{
            if (res.data.code == 200) {
                if(res.data.data && res.data.data !== '') {
                    this.isdisabled = true;
                    let result = res.data.data;
                    this.cancelRealNameInfo.applyName = result.applyName;
                    this.cancelRealNameInfo.applyPhone = result.applyPhone;
                    this.cancelRealNameInfo.applyIDCard = result.applyIDCard.toUpperCase();
                    this.cancelRealNameInfo.remark = result.applyRemark;
                    this.cancelRealNameInfo.processState = result.disposeState == 1? '待处理':(result.disposeState == 2? '拒绝':'通过');
                    this.cancelRealNameInfo.processResult = result.disposeRemark;
                }
                else {
                    this.cancelRealNameInfo.processResult = '未申请'
                }
            }
            else {
                Dialog.alert({title:'提示', message: res.data.message});
            }
        })
    }
}
</script>

<style>
.tips {
    color: red;
    line-height: 16px;
    font-size: 12px;
}
</style>